import { type UseQueryResult, useQuery } from 'react-query';
import { EmployeeTypeService } from '../../services/wealthlane-customer-services';
import { EarlyExerciseConfigurationService } from '../../services/wealthlane-award-settlement-services';

const useGetCashSellTypeSettlementType = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const cashSellTypeSettlementType = useQuery(
    ['getCashSellTypeSettlementType'],
    async () => {
      return await handleRequest(
        EarlyExerciseConfigurationService.getApiAwardSettlementApiAppEarlyExerciseConfigurationCashSellTypeSettlementTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.settlementType ?? '',
            value: item.settlementTypeId ?? '',
          };
        });
      },
    }
  );

  return cashSellTypeSettlementType;
};

export default useGetCashSellTypeSettlementType;
